module.exports = __webpack_public_path__ + "static/slide1-d8ebf7461614b457de1290a832c9c4ac.jpg";